import i18next from 'i18next';
import ReactDOM from 'react-dom';
import React, { Suspense } from 'react';
import { initReactI18next } from 'react-i18next';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import LoadTranslations from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import App from './Components/App';
import { appReducer } from './Context/App/reducer';
import { AppProvider } from './Context/App/Provider';
import { adminReducer } from './Context/Admin/reducer';
import { AdminProvider } from './Context/Admin/Provider';
import { realtimeReducer } from './Context/Realtime/reducer';
import { RealtimeProvider } from './Context/Realtime/Provider';
import { reportingReducer } from './Context/Reporting/reducer';
import { ReportingProvider } from './Context/Reporting/Provider';
import { eventReducer } from './Context/Event/reducer';
import { EventProvider } from './Context/Event/Provider';

i18next // translation module
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(LoadTranslations)
  .init({
    backend: {
      loadPath: '/assets/locales/{{lng}}.json'
    },
    detection: {
      caches: ['localStorage'],
      lookupLocalStorage: 'lang',
      order: ['localStorage', 'navigator']
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr']
  });

// Show blank page for the couple of milliseconds translations take to load
const loading = {
  top: 0,
  left: 0,
  zIndex: 99,
  width: '100wv',
  height: '100vh',
  position: 'absolute',
  backgroundColor: '#eee'
};

// Set Material-UI Pro License Key
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY);


ReactDOM.render( // Stack of the different contexts
  <React.StrictMode>
    <Suspense fallback={<div style={loading}/>}>
      <AppProvider reducer={appReducer}>
        <ReportingProvider reducer={reportingReducer}>
          <RealtimeProvider reducer={realtimeReducer}>
            <AdminProvider reducer={adminReducer}>
              <EventProvider reducer={eventReducer}>
              <App/>
              </EventProvider>
            </AdminProvider>
          </RealtimeProvider>
        </ReportingProvider>
      </AppProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);
